































import { Component, Vue, PropSync, Watch } from 'vue-property-decorator';
import { Dialog, Button, Table, TableColumn, MessageBox } from 'element-ui';
import { eventHub } from '@/libraries/event-hub';
import GuApiRestClient from '@/libraries/gu-api-client';
import Project from '@/models/project';
import { MessageBoxInputData } from 'element-ui/types/message-box';

@Component({
  components: {
    'el-dialog': Dialog,
    'el-button': Button,
    'el-table': Table,
    'el-table-column': TableColumn,
  },
})
export default class ProjectsDialog extends Vue {
  @PropSync('showDialog', { type: Boolean, default: false }) private show!: boolean;

  private projects?: Project[] = [];
  private isLoading: boolean = false;
  private apiClient = new GuApiRestClient();

  @Watch('show')
  private async onShowChanged(newVal: boolean) {
    this.projects = [];
    if (newVal) {
      this.isLoading = true;
      await this.loadProjects();
      this.isLoading = false;
    }
  }

  private async loadProjects(): Promise<void> {
    const response = await this.apiClient.getProjects();
    this.projects = response.data.sort((a: Project, b: Project) => a.created! - b.created!).reverse();
  }

  private handleOpen(project: Project) {
    eventHub.$emit('open-project', project);
    this.show = false;
  }

  private addProject(): void {
      MessageBox.prompt('Proje ismi girin', 'Proje İsmi', {
          confirmButtonText: 'Kaydet',
          cancelButtonText: 'İptal',
        }).then(async (input) => {
          let project = new Project();
          project.name = (input as MessageBoxInputData).value;
          const response = await this.apiClient.addProject(project);
          project = response.data;
          if (this.projects) {
            this.projects.push(project);
          }
        }).catch((_) => _);
  }

  private handleDelete(project: Project) {
    MessageBox.confirm(
      'Bu işlem projeyi tamamen silecek. Onaylıyor musunuz?',
      'Uyarı',
      {
          confirmButtonText: 'Onayla',
          cancelButtonText: 'İptal',
          type: 'warning',
      }).then(async () => {
        if (project.projectId) {
          await this.apiClient.deleteProject(project.projectId);
          await this.loadProjects();
        }
      }).catch((_) => _);
  }
}
